// extracted by mini-css-extract-plugin
module.exports = {"container":"_4f720283bf--container--mZQp4","slide":"_4f720283bf--slide--ofqxm"};